import apiFetch from '../apiFetch'

export default function (token, manager) {
  return apiFetch({ endPoint: 'ProcessingAgencyManagers/Create', method: 'POST', body: manager, token: token })
}
